import PropTypes from "prop-types"
import React from "react"

const HeadingHeroTitle = ({ children }) => {
  return (
    <div
      data-design-system="HeadingHeroTitle"
      aria-level="1"
      role="heading"
      className="text-[42px] font-bold leading-tight text-gray-900"
    >
      {children}
    </div>
  )
}

HeadingHeroTitle.propTypes = {
  children: PropTypes.node.isRequired,
}

export default HeadingHeroTitle
